import { Payload } from '../models/payload.model';

/**
 * Obtiene el valor de una cookie según su nombre
 * @param cookies cookies en el navegador
 * @param cname nombre de la cookie a obtener el valor
 * @returns
 */
export const getCookie = (cookies: string, cname: string): string => {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(cookies);
    const ca = decodedCookie.split(';');

    for (const c of ca) {
        let _c = c;
        while (_c.startsWith(' ')) {
            _c = _c.substring(1);
        }
        if (_c.startsWith(name)) {
            return _c.substring(name.length, _c.length);
        }
    }
    return null;
};

/**
 * Unique identifier of a user session
 * Must be the same during a complete interaction of an user and keep the same value in all kindof events
 * This is the ITXSESSIONID injected by Akamai
 *
 * @returns string
 */
export const getSessionId = (cookies: string): string => {
    return getCookie(cookies, 'ITXSESSIONID');
};

/**
 * UNIX Epoch in milliseconds when the event occurred in local time
 *
 * @returns number
 */
export const getTimestamp = (): number => {
    return Date.now();
};

/**
 * Content of the event, information associated with the event
 *
 * @param context
 * @returns Payload
 */
export const getPayload = (context: any, cookies: string): Payload => {
    return {
        context,
        sessionId: getSessionId(cookies),
        timestamp: getTimestamp(),
    };
};
